import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AutorizacionDetallePage } from "@/features/autorizacion/components/AutorizacionDetallePage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";

/**
 * Ruta `/autorizacion/$id` · vista del autorizador. Precarga la solicitud
 * (mismo `queryOptions` que /solicitudes/$id · cache compartido).
 */
export const Route = createFileRoute("/_authed-tw/autorizacion/$id")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: () => (
    <PermissionGate permisos={[PERMISOS.autorizacionAutorizar]}>
      <AutorizacionDetallePage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
